import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobDetailsComponent } from "./job-details/job-details.component";
import { Error404Component } from "./error-404/error-404.component";
import { OauthTokenGuard } from './oauth/oauth-token.guard';
import { AuthenticationGuard } from './oauth/authentication.guard';
import { OAuthCallbackComponent } from './oauth/oauth-callback.component';
import { LoginComponent } from './oauth/login.component';


import {
  BUSINESS,
  EXECUTIONS,
  EXECUTIONS_RESOURCE,
  EXECUTIONS_RESOURCE_APPLICATION,
  EXECUTIONS_RESOURCE_APPLICATION_LOCATION,
  EXECUTIONS_RESOURCE_APPLICATION_LOCATION_JOB,
  HOME_PAGE,
  JOB_DEFINITION_PAGE,
  JOB_LOG_PAGE,
  LOGIN_PAGE,
  SIDEBAR
} from "./services/shared-data.service";
import { ExecutionsComponent } from "./executions/executions.component";
import { BusinessComponent } from './business/business.component';
import { RobotDashboardComponent } from "./robot-dashboard/robot-dashboard.component";
import { SideBarComponent } from "./side-bar/side-bar.component";
import { JobsComponent } from "./jobs/jobs.component";
import { ActiveJobsComponent } from "./active-jobs/active-jobs.component";
import { NewJobDetailsComponent } from "./new-job-details/new-job-details.component";
import { JoblogviewComponent } from './joblogview/joblogview.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: LOGIN_PAGE, component: LoginComponent },
  { path: 'oauth', component: OAuthCallbackComponent, canActivate: [OauthTokenGuard] },
  { path: JOB_DEFINITION_PAGE, component: JobDetailsComponent, canActivate: [AuthenticationGuard] },
  { path: JOB_LOG_PAGE, component: JoblogviewComponent, canActivate: [AuthenticationGuard] },
  { path: HOME_PAGE, component: RobotDashboardComponent, canActivate: [AuthenticationGuard] },
  { path: 'oldTable', component: JobsComponent, canActivate: [AuthenticationGuard] },
  { path: 'activeJobs', component: ActiveJobsComponent, canActivate: [AuthenticationGuard] },
  { path: 'newDetails', component: NewJobDetailsComponent, canActivate: [AuthenticationGuard] },
  { path: SIDEBAR, component: SideBarComponent, canActivate: [AuthenticationGuard] },
  { path: EXECUTIONS, component: ExecutionsComponent, canActivate: [AuthenticationGuard] },
  { path: EXECUTIONS_RESOURCE, component: ExecutionsComponent, canActivate: [AuthenticationGuard] },
  { path: EXECUTIONS_RESOURCE_APPLICATION, component: ExecutionsComponent, canActivate: [AuthenticationGuard] },
  { path: EXECUTIONS_RESOURCE_APPLICATION_LOCATION, component: ExecutionsComponent, canActivate: [AuthenticationGuard] },
  { path: EXECUTIONS_RESOURCE_APPLICATION_LOCATION_JOB, component: ExecutionsComponent, canActivate: [AuthenticationGuard] },
  { path: BUSINESS, component: BusinessComponent },
  { path: '**', component: Error404Component },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { useHash: false })]
})

export class AppRoutingModule {



}
